import { render, staticRenderFns } from "./StartsOn.vue?vue&type=template&id=3ff045b2&"
import script from "./StartsOn.vue?vue&type=script&lang=js&"
export * from "./StartsOn.vue?vue&type=script&lang=js&"
import style0 from "./StartsOn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports